import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            redirect: '/login'
        },
        {
            path: '/login',
            component: resolve => require(['../components/page/Login.vue'], resolve)
        },
        {
            path: '/',
            component: resolve => require(['../components/common/Home.vue'], resolve),
            meta: {title: '自述文件'},
            children: [
                {
                    path: '/index',
                    component: resolve => require(['../components/page/Index.vue'], resolve),
                    meta: {title: '系统首页'}
                },
                {
                    path: '/user',
                    component: resolve => require(['../components/page/User.vue'], resolve),
                    meta: {title: '用户列表'}
                },
                {
                    path: '/blocks',
                    component: resolve => require(['../components/page/Blocks.vue'], resolve),
                    meta: {title: '封禁用户列表'}
                },
                {
                    path: '/sensitive',
                    component: resolve => require(['../components/page/Sensitive.vue'], resolve),
                    meta: {title: '敏感词列表'}
                },
                {
                    path: '/sensitiveShot',
                    component: resolve => require(['../components/page/SensitiveShot.vue'], resolve),
                    meta: {title: '敏感词命中'}
                },
                {
                    path: '/updatePwd',
                    component: resolve => require(['../components/page/UpdatePwd.vue'], resolve),
                    meta: {title: '更新密码'}
                },
                {
                    path: '/updateIcon',
                    component: resolve => require(['../components/page/UpdateIcon.vue'], resolve),
                    meta: {title: '更新头像'}
                },
                {
                    path: '/updatePhone',
                    component: resolve => require(['../components/page/UpdatePhoneNumber.vue'], resolve),
                    meta: {title: '更新手机号'}
                },
                {
                    path: '/groupView',
                    component: resolve => require(['../components/page/GroupView.vue'], resolve),
                    meta: {title: '群组管理'}
                },
                {
                    path: '/messageView',
                    name: 'message',
                    component: resolve => require(['../components/page/Message.vue'], resolve),
                    meta: {title: '消息管理'}
                },
                {
                    path: '/maxGroupUserNum',
                    name: 'maxGroupUserNum',
                    component: resolve => require(['../components/page/MaxGroupUserNum.vue'], resolve),
                    meta: {title: '群最大人数设置'}
                },
                {
                    path: '/channel',
                    name: 'channel',
                    component: resolve => require(['../components/page/Channel.vue'], resolve),
                    meta: {title: '频道管理'}
                },
                {
                    path: '/robots',
                    name: 'robots',
                    component: resolve => require(['../components/page/Robot.vue'], resolve),
                    meta: {title: '机器人管理'}
                },
                {
                    path: '/broad',
                    name: 'broad',
                    component: resolve => require(['../components/page/BroadCast.vue'], resolve),
                    meta: {title: '广播消息'}
                },
                {
                    path: '/groupMsg',
                    name: 'groupMsg',
                    component: resolve => require(['../components/page/GroupMessage.vue'], resolve),
                    meta: {title: '群发消息'}
                },
                {
                    path: '/userMsg',
                    name: 'userMsg',
                    component: resolve => require(['../components/page/UserMsg.vue'], resolve),
                    meta: {title: '用户消息'}
                }]
        },
        {
            path: '/403',
            component: resolve => require(['../components/page/403.vue'], resolve)
        },
        {
            path: '/404',
            component: resolve => require(['../components/page/404.vue'], resolve)
        },
        {
            path: '*',
            redirect: '/404'
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js